import debug from 'debug';
import CloudApi from './CloudApi'

const log = debug('CloudApi:Customers');

/**
 * @deprecated use api-management instead, and create missing functionality
 */
class Customers extends CloudApi {

	/**
	 * @param {Object} options
	 * @param {string} options.customerType
	 * @param {boolean} options.showFeedCatalogs
	 */
	CustomersWithLinksAndCatatalogs({ customerType, showFeedCatalogs }) {
		let url = `//${this.settings.cloudApiUrl}/Customers/withlinksandcatalogs?customerType=${ customerType }&includeFeeds=${ showFeedCatalogs }`;
		return this.Get(url);
	}
}

export default Customers;
